module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gd8QS"))).then(() => parcelRequire('d0iPb'));